import { TextCell } from '@ayocore/platform/client/components/EditableGrid';
import type { EditableGridColumn } from '@ayocore/platform/client/components/EditableGrid';
import type { WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey } from './types';

export const workOrderDescriptionColumn: EditableGridColumn<
  WorkOrderRow,
  WorkOrderPatch,
  WorkOrderColumnKey
> = TextCell<WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey>({
  key: 'work_description',
  title: 'Описание работ',
  width: 220,
  placeholder: 'Опишите работы/услуги...',
  multiline: 'auto',
});
